import Button from '@/common/components/base/button/Button';
import Typography from '@/common/components/base/typography/Typography';
import { FetchedCorrectiveImageCardType } from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/correctiveImages/components/fetchedImages/components/fetchedCorrectiveImageCard/FetchedCorrectiveImageCard.type';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
import RefreshIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/refershIcon.svg?react';
import CheckIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/checkIcon.svg?react';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import LoadingButton from '@/common/components/base/button/loadingButton';
import React, { useState } from 'react';
import MainModal from '@/common/components/base/modal/Modal';
import AceeptRecievedIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/acceptRecievedImagesIcon.svg?react';
import RejectRecievedIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/rejectRecievedImagesIcon.svg?react';
const FetchedCorrectiveImageCard = ({
  image,
  title,
  accept,
  acceptLoading = false,
  reject,
  rejectLoading = false,
}: FetchedCorrectiveImageCardType) => {
  const [acceptOrReject, setAcceptOrReject] = useState<
    'accept' | 'reject' | null
  >(null);
  return (
    <React.Fragment>
      <Box
        display={'flex'}
        flexDirection={'row'}
        backgroundColor="white"
        borderRadius="8px"
        shadow="cardShadow"
        gap={'1rem'}
        p={8}
      >
        <Box>
          <ImageCard
            imageData={{
              src: image,
            }}
          />
        </Box>
        <Box
          flexGrow={1}
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'space-between'}
          textAlign={'center'}
        >
          <Box borderBottom={'1px solid {colors.gray-3}'} p={'1rem'}>
            <Typography textStyle={'b2'}>{title}</Typography>
          </Box>

          <Box
            className={css({
              display: 'flex',
            })}
          >
            {' '}
            <Button
              gap="5px"
              fullWidth
              fontSize={'11px'}
              variant="text"
              color="common"
              display={'flex'}
              w={'100%'}
              textWrap={'nowrap'}
              onClick={() => setAcceptOrReject('reject')}
              disabled={rejectLoading || rejectLoading}
            >
              <RefreshIcon />
              <Typography
                textStyle={'b4'}
                className={css({ color: 'black-3' })}
              >
                {rejectLoading && (
                  <LoadingButton loading={acceptLoading} color={'common'} />
                )}
                درخواست مجدد
              </Typography>
            </Button>
            <Button
              gap="5px"
              fullWidth
              fontSize={'11px'}
              variant="text"
              color="common"
              display={'flex'}
              w={'100%'}
              textWrap={'nowrap'}
              borderRight={'1px solid {colors.gray-3}'}
              onClick={() => setAcceptOrReject('accept')}
              disabled={acceptLoading || rejectLoading}
            >
              <CheckIcon />
              <Typography
                textStyle={'b4'}
                className={css({
                  color: 'purple-2',
                })}
              >
                {acceptLoading && (
                  <LoadingButton loading={acceptLoading} color={'primary'} />
                )}
                تائید تصویر
              </Typography>
            </Button>
          </Box>
        </Box>
      </Box>
      <MainModal
        open={acceptOrReject === 'accept'}
        closeModal={() => setAcceptOrReject(null)}
      >
        <Box
          className={css({
            textAlign: 'center',
          })}
        >
          <Box
            className={css({
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            })}
          >
            <AceeptRecievedIcon />
            <Typography mt={'1rem'}>
              {`آیا برای تایید تصویر “ ${title}“ مطمئن هستید ؟`}
            </Typography>
          </Box>
          <Box className={css({ display: 'flex', gap: '1rem', mt: '3rem' })}>
            <Button
              variant="outlined"
              color="common"
              fullWidth
              onClick={() => setAcceptOrReject(null)}
            >
              انصراف
            </Button>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => {
                if (acceptOrReject === 'accept') {
                  accept?.();
                } else {
                  reject?.();
                }
                setAcceptOrReject(null);
              }}
            >
              تایید
            </Button>
          </Box>
        </Box>
      </MainModal>
      <MainModal
        open={acceptOrReject === 'reject'}
        closeModal={() => setAcceptOrReject(null)}
      >
        <Box>
          <Box
            className={css({
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            })}
          >
            <RejectRecievedIcon />
            <Typography mt={'1rem'}>
              {`آیا برای درخواست مجدد تصویر “${title} “ مطمئن هستید ؟`}
            </Typography>
          </Box>
          <Box className={css({ display: 'flex', gap: '1rem', mt: '3rem' })}>
            <Button
              variant="outlined"
              color="common"
              fullWidth
              onClick={() => setAcceptOrReject(null)}
            >
              انصراف
            </Button>
            <Button
              variant="contained"
              color="danger"
              fullWidth
              onClick={() => {
                reject?.();
                setAcceptOrReject(null);
              }}
            >
              درخواست مجدد
            </Button>
          </Box>
        </Box>
      </MainModal>
    </React.Fragment>
  );
};

export default FetchedCorrectiveImageCard;
